import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import { ThunkDispatch } from 'redux-thunk';

import { loadJobDetails } from '../../action/job/load-job-details';
import { loadJobRoles } from '../../action/load-job-roles';
import { jobRoleSelector } from '../../reducers/job-role-selectors';
import { jobDetailsSelector } from '../../reducers/job-selectors';

import { JobFieldExperience } from '../../job/fields/job-field-experience';

import { JobFlowButtons } from './job-flow-buttons';

import { IMAGE_PATH } from '../../config/config';

const FORM_NAME = 'jobFlowExperience';

const mapStateToProps = (state: any, ownProps: InputProps) => {
  const jobDetails = ownProps.jobId ? jobDetailsSelector(state, ownProps.jobId) : undefined;
  const selector = formValueSelector(FORM_NAME);

  return {
    jobDetails,
    relevantExperience: selector(state, 'relevantExperience') || [],
    jobRole: ownProps.jobRoleId ? jobRoleSelector(state, ownProps.jobRoleId) : undefined,
    initialValues: { relevantExperience: jobDetails?.relevantExperience },
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadJobDetails: () => (ownProps.jobId ? dispatch(loadJobDetails(ownProps.jobId)) : undefined),
    loadJobRoles: () => dispatch(loadJobRoles()),
  },
});

interface InputProps extends JobFlowStep {
  jobId?: number;
  jobRoleId?: number | null;
}

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type JobFlowExperienceComponentProps = InputProps & StateProps & DispatchProps;
type JobFlowExperienceFields = Partial<Job>;
type Props = InjectedFormProps<JobFlowExperienceFields, JobFlowExperienceComponentProps> &
  JobFlowExperienceComponentProps;

class JobFlowExperienceComponent extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.actions.loadJobDetails();
    this.props.actions.loadJobRoles();
  }

  componentDidUpdate(prevProps: Props) {
    this.props.actions.loadJobDetails();
    this.props.actions.loadJobRoles();
    if (prevProps.dirty !== this.props.dirty) {
      this.props.onDirty(this.props.dirty);
    }
  }

  render() {
    const {
      onPrev,
      onNext,
      onSkip,
      jobId,
      jobDetails,
      handleSubmit,
      relevantExperience,
      saving,
      jobRole,
      editing,
    } = this.props;

    if (!jobId || !jobDetails || !jobDetails.relevantExperience) {
      return null;
    }

    return (
      <form onSubmit={handleSubmit(onNext)}>
        <JobFieldExperience
          jobId={jobId}
          jobDetails={jobDetails}
          suggestions={jobRole && jobRole.suggestedExperiences}
        />
        <div className="u-padding-xl">
          <div className="typo-h6">Example</div>
          <div className="typo-subtitle">
            Here&apos;s how applicants will be asked about your experience requirements
          </div>
          <div className="u-textAlign-center">
            <img
              className="u-width-85 card u-margin-top-xl"
              src={`${IMAGE_PATH}/experience-example.png`}
              alt="Experience Example"
            />
          </div>
        </div>
        <JobFlowButtons
          disabled={!relevantExperience.length}
          onPrev={onPrev}
          onSkip={onSkip}
          editing={editing}
          saving={saving}
        />
      </form>
    );
  }
}

export const JobFlowExperience = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm<JobFlowExperienceFields, JobFlowExperienceComponentProps>({
    form: FORM_NAME,
    enableReinitialize: true,
  })(JobFlowExperienceComponent),
);
